import Header from '@/components/Header'
import React from 'react'
import MessagesPage from '../Messages'
import useDocumentTitle from '@/components/Helmet'

const Chat = () => {
    useDocumentTitle("Chat");
    return (
        <div className=" bg-gray-50">
            <Header />
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
                <h2 className="text-2xl font-semibold">Chat</h2>
                <MessagesPage/>
            </section>
        </div>
    )
}

export default Chat